<template>
  <div>
    <h1 class="">Tarefas</h1>

    <SGPBotaoAdicionarNovoComponent
      @sgpAdiconarNovoEmit="adicionarNovo"
    />

    <SGPFiltroComponent
      @sgpFiltroTextInputChange="processaFiltroPorTexto"
    />

    <SGPTabelaComponent
      v-if="listagemDeTarefas.length"
      :key="textoFiltroTabela"
      :colunas="colunas"
      :dados="listagemDeTarefas"
      :filtroText="true"
      @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
      @sgpTabelaEditarSelecionadoEmit="editarSelecionado"
      @sgpTabelaDeletarSelecionadoEmit="deletarSelecionado"
      @sgpTabelaModalCadastrarEmit="abrirImageProcesso"
      :textoParaFiltragem="textoFiltroTabela"
    ></SGPTabelaComponent>

    <SGPAlertaComponent v-else></SGPAlertaComponent>
    
    <SGPModalComponent
      v-if="abrirModal"
      tamanho="lg"
      titulo="Tarefa"
      @sgpModalFechar="fecharModal"
      :mostrarFooter="false"
    >
      <FormularioTarefaComponent
        @sgpModalFechar="fecharModal"
        :tipoFormulario="tipoFormulario"
        :tarefa="tarefa"
      />
    </SGPModalComponent> 

    <SGPModalImagemComponent
      v-if="abrirModalImage"
      :titulo="tarefaMobilidade.tarefa"
      @sgpModalFechar="fecharModal"
      :mostrarFooter="false"
      :url="tarefaMobilidade.imageModal"
    >
    </SGPModalImagemComponent> 
    
    <SGPConfirmacaoDelecaoComponent
      v-if="deletarDados"
      @sgpCancelarDelecaoEmit="cancelarDelecao()"
      @sgpConfirmarDelecaoEmit="confirmarDelecao()"
    />
    
    <SGPLoadingComponent v-if="loadingTarefas"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FormularioTarefaComponent from '../components/FormularioTarefaComponent.vue'
import moduleReload from '@/common/mixins/module-reload'

export default {
  components: { FormularioTarefaComponent},
  mixins: [moduleReload],
  name: 'TarefaPage',

  data () {
    return {
      mostrarSelecionar: true,
      mostrarEditar: true,
      mostrarDeletar: true,
      tarefasSelecionadas: [],
      abrirModal: false,
      abrirModalImage: false,
      deletarDados: false,
      tipoFormulario: 'salvar',
      tarefa: {},
      tarefaMobilidade: {},
      textoFiltroTabela: '',
      opcoesSimNao: {
        0: 'Não',
        1: 'Sim'
      },
    }
  },
  created () {
    this.listarTarefas();
    // this.listarStar21Pendencias();
    this.listarProcessos();
    // this.listarTiposTarefas();
    // this.listarFormularios();
  },
  computed: {
    ...mapGetters('ctrlTarefas', ['listaDeTarefas','loadingTarefas']),

    listagemDeTarefas(){
      return this.listaDeTarefas
        .filter(tarefa => tarefa.deleted_at == null)
        .map(tarefa => {
            // tarefa.redirecionar = `/sgp/tarefas-mobilidades/${tarefa.id}`;

            tarefa.imageModal = false;
            if (tarefa.url_file_processo?.length) {
              tarefa.imageModal = tarefa.url_file_processo;
            }
            tarefa.agrupavel_string = this.opcoesSimNao[tarefa.agrupavel];
            tarefa.mantem_bloco_apos_tratamento_string = this.opcoesSimNao[tarefa.mantem_bloco_apos_tratamento]
            tarefa.is_last_tarefa_string = this.opcoesSimNao[tarefa.is_last_tarefa ? 1 : 0];
            // tarefa.incluir_tarefa_string = this.opcoesSimNao[tarefa.incluir_nova_tarefa_pco_tarefa]
            // tarefa.habilitado_extracao_string = this.opcoesSimNao[tarefa.habilitado_extracao]
            // tarefa.instalavel_string = this.opcoesSimNao[tarefa.instalavel]
            // tarefa.ativo_string = this.opcoesSimNao[tarefa.ativo];

            return tarefa;
        });
    },

    colunas () {
      return [
        {
          key: 'selecionar',
          label: '',
          sortable: false
        }, 
        {
          key: 'tarefa',
          label: 'Nome',
          sortable: true
        },
        {
          key: 'map',
          label: 'Map',
          sortable: true
        },
        {
          key: 'processo.processo',
          label: 'Processo',
          sortable: true
        },
        {
          key: 'tipo_tarefa.tipo',
          label: 'Tipo de Tarefa',
          sortable: true
        },
        {
          key: 'imageModal',
          label: 'Img Processo',
          sortable: true
        },
        {
          key: 'tipo_aging.tipo',
          label: 'Tipo de Aging',
          sortable: true
        },
        {
          key: 'aging',
          label: 'Aging',
          sortable: true
        },
        {
          key: 'agrupavel_string',
          label: 'Agrupável',
          sortable: true
        },
        {
          key: 'mantem_bloco_apos_tratamento_string',
          label: 'Mantém Bloco Após Tratamento',
          sortable: true
        },
        {
          key: 'is_last_tarefa_string',
          label: 'É Última Tarefa',
          sortable: true
        },
        // {
        //   key: 'instalavel_string',
        //   label: 'Instalável',
        //   sortable: true
        // },
        // {
        //   key: 'incluir_tarefa_string',
        //   label: 'Incluir Nova Tarefa',
        //   sortable: true
        // },
        // {
        //   key: 'habilitado_extracao_string',
        //   label: 'Habilitado Extração',
        //   sortable: true
        // },
        {
          key: 'ordem',
          label: 'Ordem',
          sortable: true
        },
        // {
        //   key: 'ativo_string',
        //   label: 'Ativo',
        //   sortable: true,
        // }
      ]
    },
  },

  methods: {
    ...mapActions('ctrlTarefas', 
    [
      'listarTarefas',
      'excluirTarefas'
    ]),
    // ...mapActions('star21Pendencias', 
    // [
    //   'listarStar21Pendencias'
    // ]),
    ...mapActions('ctrlProcessos', 
    [
      'listarProcessos'
    ]),
    // ...mapActions('tiposTarefas', 
    // [
    //   'listarTiposTarefas'
    // ]),

    // ...mapActions('formularios', ['listarFormularios']),

    processaFiltroPorTexto (val) {
      this.textoFiltroTabela = val
    },

    gerenciadorDeSelecionados (selecionados) {
      this.tarefasSelecionadas = selecionados;
    },

    editarSelecionado () {
      this.tipoFormulario = 'editar';
      this.tarefa = this.tarefasSelecionadas[0];      
      this.abrirModal = true;
      
    },

    deletarSelecionado () {
      this.deletarDados = true;
    },

    cancelarDelecao () {
      this.deletarDados = false;
    },

    confirmarDelecao () {
      this.excluirTarefas(this.tarefasSelecionadas);
      this.deletarDados = false;
    },

    adicionarNovo () {
      this.tarefa = {};
      this.tipoFormulario = 'salvar';
      this.abrirModal = true;
    },

    fecharModal () {
      this.abrirModal = false;
      this.abrirModalImage = false;
    },

    abrirImageProcesso (tarefa) {
      this.tarefaMobilidade = tarefa;
      this.abrirModalImage = true;
    },

    reloadData () {
      this.listarTarefas();
      this.listarProcessos();
    }

  }
}
</script>
